import React, { Component } from 'react'
import Card from './Card'
import SessionCard from './SessionCard'
import './top_appointment.css'

class AppointmentCard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            details: [],
            selectedDetail: 0
        }
        this.getDetails = this.getDetails.bind(this)
        this.prevAppointment = this.prevAppointment.bind(this)
        this.nextAppointment = this.nextAppointment.bind(this)
    }
    componentDidMount() {
        this.getDetails()
    }
    componentDidUpdate(prevProps, _) {
        if (prevProps.appointments !== this.props.appointments) {
            this.getDetails()
        }
        if (prevProps.selectedDay !== this.props.selectedDay || prevProps.selectedAppointment !== this.props.selectedAppointment) {
            let index = this.state.details.findIndex(item => item.key === `${this.props.selectedDay}_${this.props.selectedAppointment}`)
            if (index >= 0) {
                this.setState({
                    selectedDetail: index
                })
                if (this.swipeControl) {
                    this.swipeControl.slide(index, 10)
                }
            }
        }
    }
    getDetails() {
        let details = []
        this.props.appointments.forEach((appointment, index) => {
            let day = appointment.day
            appointment.details.forEach((item, index1) => {
                let key = `${day}_${index1}`
                let detail = item
                details.push({ key, detail })
            })
        })
        this.setState({
            details
        })
    }
    prevAppointment() {
        if (this.state.details.length > 0) {
            let index = this.state.selectedDetail
            index = (((index - 1) % this.state.details.length) + this.state.details.length) % this.state.details.length
            let key = this.state.details[index].key
            this.props.selectAppointment(key.split('_')[0], parseInt(key.split('_')[1]))
        }
    }
    nextAppointment() {
        if (this.state.details.length > 0) {
            let index = this.state.selectedDetail
            index = (index + 1) % this.state.details.length
            let key = this.state.details[index].key
            this.props.selectAppointment(key.split('_')[0], parseInt(key.split('_')[1]))
        }
    }
    render() {
        return (
            <div className='appointment_card'>
                <div className='appointment_card_stage'>
                    <div className='card_arrow appointment_card_arrow' onClick={this.prevAppointment}>
                        <i className="fas fa-chevron-left fa-1x"></i>
                    </div>
                    <div className='appointment_card_content'>
                        <div style={{ width: '100%' }}>
                            {this.state.details.length > 0 && this.state.details[this.state.selectedDetail] && (
                                <div>
                                    {
                                        this.state.details[this.state.selectedDetail].detail.schedule_id 
                                        ? <SessionCard detail={this.state.details[this.state.selectedDetail]} index={this.state.selectedDetail} user={this.props.user} /> 
                                        : <Card user={this.props.user} canCheckIN={this.props.canCheckIN} onCheckIn={this.props.checkIn} onCheckOut={this.props.checkOut} showWarnMod={this.props.showWarnMod} onCancel={this.props.cancelAppoinntment} onReschedule={this.props.rescheduleAppointment} detail={this.state.details[this.state.selectedDetail]} index={this.state.selectedDetail} />
                                    }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='card_arrow appointment_card_arrow' onClick={this.nextAppointment}>
                        <i className="fas fa-chevron-right fa-1x"></i>
                    </div>
                </div>
                <div className='appointment_card_nav'>
                    {this.state.details.map((item, index) => (
                        <div
                            key={index}
                            className={`appointment_card_nav_bullet ${item.key.split('_')[0] === this.props.selectedDay && parseInt(item.key.split('_')[1]) === this.props.selectedAppointment ? 'ACTIVE' : 'INACTIVE'}`}
                            onClick={() => this.props.selectAppointment(item.key.split('_')[0], parseInt(item.key.split('_')[1]))}
                        />
                    ))}
                </div>
            </div>
        )
    }
}

export default AppointmentCard
